import {
  UserRound,
  Eye,
  Users,
  List,
  Bookmark,
  Briefcase,
  Stethoscope,
  MapPin,
  Camera,
  PenLine,
  BarChart3,
  UserPlus,
  Heart,
  MessageSquare,
  Share2,
} from "lucide-react";

/* Community feed tour content, ported from the mobile "Community" mockup.
   The per-post steps target the FIRST feed post, which is the only card that
   carries the tour hooks. The generic GuidedTour engine renders these; this
   is just the data. (The mockup's "Topic" filter isn't in the real page, so
   the third filter step uses the Location chip instead.) */
export default function getCommunityTourSteps() {
  return [
    {
      cardSelector: '[data-tour="cm-profile"]',
      targetSelector: '[data-tour="cm-profile"]',
      icon: <UserRound />,
      title: "Your profile",
      text: "Your role and location — this is how you appear in the community.",
    },
    {
      cardSelector: '[data-tour="cm-tabbar"]',
      targetSelector: '[data-tour="cm-tab-for-you"]',
      icon: <Eye />,
      title: "For You",
      text: "A personalized feed based on your role and interests.",
    },
    {
      cardSelector: '[data-tour="cm-tabbar"]',
      targetSelector: '[data-tour="cm-tab-following"]',
      icon: <Users />,
      title: "Following",
      text: "Only posts from the nurses you follow.",
    },
    {
      cardSelector: '[data-tour="cm-tabbar"]',
      targetSelector: '[data-tour="cm-tab-all"]',
      icon: <List />,
      title: "All",
      text: "Every recent post across the community.",
    },
    {
      cardSelector: '[data-tour="cm-tabbar"]',
      targetSelector: '[data-tour="cm-tab-saved"]',
      icon: <Bookmark />,
      title: "Saved",
      text: "The posts you bookmarked, kept in one place.",
    },
    {
      cardSelector: '[data-tour="cm-filters"]',
      targetSelector: '[data-tour="cm-filter-profession"]',
      icon: <Briefcase />,
      title: "Profession",
      text: "Narrow the feed down to a profession.",
    },
    {
      cardSelector: '[data-tour="cm-filters"]',
      targetSelector: '[data-tour="cm-filter-specialty"]',
      icon: <Stethoscope />,
      title: "Specialty",
      text: "Filter posts by clinical specialty.",
    },
    {
      cardSelector: '[data-tour="cm-filters"]',
      targetSelector: '[data-tour="cm-filter-location"]',
      icon: <MapPin />,
      title: "Location",
      text: "Focus on posts from a specific state or city.",
    },
    {
      cardSelector: '[data-tour="cm-compose"]',
      targetSelector: '[data-tour="cm-compose-camera"]',
      icon: <Camera />,
      title: "Add a photo",
      text: "Attach a photo or paystub to your post.",
    },
    {
      cardSelector: '[data-tour="cm-compose"]',
      targetSelector: '[data-tour="cm-compose-post"]',
      icon: <PenLine />,
      title: "Post",
      text: "Share a written update with the community.",
    },
    {
      cardSelector: '[data-tour="cm-compose"]',
      targetSelector: '[data-tour="cm-compose-poll"]',
      icon: <BarChart3 />,
      title: "Poll",
      text: "Ask the community a question with a quick poll.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-profile"]',
      icon: <UserRound />,
      title: "View profile",
      text: "Tap a member to open their profile — view details, message them, or follow.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-follow"]',
      icon: <UserPlus />,
      title: "Follow",
      text: "Follow a member to see more of their posts.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-like"]',
      icon: <Heart />,
      title: "Like",
      text: "Show appreciation for a post.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-comment"]',
      icon: <MessageSquare />,
      title: "Comment",
      text: "Join the conversation with a reply.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-save"]',
      icon: <Bookmark />,
      title: "Save",
      text: "Bookmark a post to find it later in Saved.",
    },
    {
      cardSelector: '[data-tour="cm-postcard"]',
      targetSelector: '[data-tour="cm-pc-share"]',
      icon: <Share2 />,
      title: "Share",
      text: "Send a post to a colleague or export it.",
    },
  ];
}
